import { UserOutlined } from "@ant-design/icons";
import {
  ROUTE_FORGET_PASSWORD,
  ROUTE_LOGIN,
  ROUTE_RESET_PASSWORD,
} from "./auth.routes";
import LoginPage from "../../modules/auth/login.page";
import {
  ROUTE_DASHBOARD,
  ROUTE_MANAGE_DEPARTMENT,
  ROUTE_MANAGE_STAFF,
  ROUTE_MANAGE_PROJECT,
  ROUTE_MANAGE_BILLING_CYCLE,
  ROUTE_MANAGE_VENDOR,
  ROUTE_BILLING_SUMMARY,
  ROUTE_MANAGE_ACCOUNT,
  ROUTE_MANAGE_SUB_DEPARTMENT,
  ROUTE_MANAGE_FOREX,
} from "./private.routes";
import ManageStaffPage from "../../modules/staff/manage-staff.page";
import ManageDepartmentPage from "../../modules/department/manage-department.page";
import ManageProjectPage from "../../modules/project/manage-project.page";
import ManageBillingCyclePage from "../../modules/project/manage-billing-cycle.page";
import ManageVendorPage from "../../modules/vendor/manage-vendor.page";
import BillingCycleSummary from "../../modules/project/billing-summary.page";
import ManageAccountsPage from "../../modules/accounts/manage-accounts.page";
import ManageSubDepartmentPage from "../../modules/department/manage-sub-department.page";
import StaffAssignmentSummaryComponent from "../../modules/project/components/staff-assignment-summary.component";
import ManageForexPage from "../../modules/forex/manage-forex.page";

export const ROUTES_OPEN: any[] = [
  {
    name: "Login",
    route: ROUTE_LOGIN,
    component: <LoginPage />,
  },
  // {
  //   name: "Reset Pasword",
  //   route: ROUTE_RESET_PASSWORD,
  //   component: <ResetPasswordPage />,
  // },
  // {
  //   name: "Forget Password",
  //   route: ROUTE_FORGET_PASSWORD,
  //   component: <ForgotPasswordPage />,
  // },
];

export const ROUTES_PROTECTED: any[] = [
  {
    name: "Dashboard",
    module: "DASHBOARD",
    route: ROUTE_DASHBOARD,
    component: (
      <>
        Dashboard
        <UserOutlined />
      </>
    ),
  },
  {
    name: "Staff",
    module: "STAFF",
    route: ROUTE_MANAGE_STAFF,
    component: <ManageStaffPage />,
  },
  {
    name: "Department",
    module: "DEPARTMENT",
    route: ROUTE_MANAGE_DEPARTMENT,
    component: <ManageDepartmentPage />,
  },
  {
    name: "Sub Department",
    module: "SUB_DEPARTMENT",
    route: ROUTE_MANAGE_SUB_DEPARTMENT,
    component: <ManageSubDepartmentPage />,
  },
  {
    name: "Project",
    module: "PROJECT",
    route: ROUTE_MANAGE_PROJECT,
    component: <ManageProjectPage />,
  },
  {
    name: "Billing Cycle",
    module: "BILLING_CYCLE",
    route: ROUTE_MANAGE_BILLING_CYCLE,
    component: <ManageBillingCyclePage />,
  },
  {
    name: "Billing Summary",
    module: "BILLING_CYCLE",
    route: ROUTE_BILLING_SUMMARY,
    // component: <BillingCycleSummary />,
    component: <StaffAssignmentSummaryComponent/>
  },
  {
    name: "Vendor",
    module: "VENDOR",
    route: ROUTE_MANAGE_VENDOR,
    component: <ManageVendorPage />,
  },
  {
    name: "Accounts",
    module: "ACCOUNTS",
    route: ROUTE_MANAGE_ACCOUNT,
    component: <ManageAccountsPage />,
  },
  {
    name: "Forex",
    module: "FOREX",
    route: ROUTE_MANAGE_FOREX,
    component: <ManageForexPage />,
  },
];
